import { z } from 'zod';
/**
 * Redirection permanente (section 7.3) : anciennes URL du site migré, slugs
 * changés. Les slugs ne sont jamais recalculés (section 4.2) ; quand la
 * galerie renomme, la régie dépose ici l'ancien chemin.
 */
export const RedirectionSchema = z
    .object({
    de: z.string().startsWith('/'),
    vers: z.string().startsWith('/'),
    statut: z.union([z.literal(301), z.literal(302), z.literal(308)]),
})
    .refine((r) => r.de !== r.vers, 'une redirection ne peut pointer sur elle-même');
/** Version publiée du site (section 7.3 : `sites/<galleryId>/<version>/`). */
export const VersionSchema = z.object({
    numero: z.number().int().positive(),
    publieLe: z.iso.datetime({ offset: true }),
});
//# sourceMappingURL=redirections.js.map